export default __webpack_public_path__ + "static/media/city.6b99b684.png";